import { GetDocumentRetrieveAllResponse } from '@shory-health-individual/customer-api';
import { DocumentTypes, HasEmiratesResponse } from '../../../../../common';
import { Member } from '../../../../../server/get-journey-details';
import { includeVisaFileNumberField } from '../../utilities';
import { DocumentsForm } from '../types';

const getDocument = (
	memberId: string,
	documentType: DocumentTypes,
	memberDocuments?: GetDocumentRetrieveAllResponse
): string | undefined => {
	const memberDocument = memberDocuments?.[memberId];
	const cdnUrl = memberDocument?.documents.find((d) => d.documentType === documentType)?.cdnUrl;

	return cdnUrl;
};

const hasEmiratesId = (member: Member, isEidFlow?: boolean) => {
	if (member.emiratesIdNumber) {
		return HasEmiratesResponse.Yes;
	}

	if (member.firstName || member.lastName || member.unifiedNumber) {
		return HasEmiratesResponse.No;
	}

	return isEidFlow ? HasEmiratesResponse.No : HasEmiratesResponse.Yes;
};

export function getInitialValues(
	isEidFlow?: boolean,
	members?: Member[],
	memberDocuments?: GetDocumentRetrieveAllResponse,
	country?: { id: number; isGCC: boolean }
): DocumentsForm {
	if (!members?.length) {
		return {};
	}

	return {
		...members.reduce(
			(acc, member) => ({
				...acc,
				[member.memberId]: {
					passportNumber: member.passportNo,
					salaryBand: member.salaryBandId,
					visaFileNumber: member.visaFileNumber,
					emiratesId: member.emiratesIdNumber ? member.emiratesIdNumber.toString().replace(/^784/, '') : undefined,
					firstName: member.firstName,
					lastName: member.lastName,
					unifiedNumber:
						member.unifiedNumber && !isNaN(Number(member.unifiedNumber)) ? Number(member.unifiedNumber) : undefined,
					hasEmiratesId: hasEmiratesId(member, isEidFlow),
					passportFile: getDocument(member.memberId, DocumentTypes.PassportScan, memberDocuments),
					visaFile: includeVisaFileNumberField(country)
						? getDocument(member.memberId, DocumentTypes.VisaScan, memberDocuments)
						: undefined,
					labourContractFile: getDocument(member.memberId, DocumentTypes.LabourContract, memberDocuments),
					insuranceContinuityFile: getDocument(
						member.memberId,
						DocumentTypes.InsuranceContinuityCertificateOrProofOfPayment,
						memberDocuments
					),
					occupationId: member.occupationId,
				},
			}),
			{}
		),
	};
}
